import { render, staticRenderFns } from "./ComponentBroker.vue?vue&type=template&id=b829067e"
import script from "./ComponentBroker.vue?vue&type=script&lang=js"
export * from "./ComponentBroker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports